export const cohortStatusSupported = (supported = false, reasons = []) => ({ reasons, supported });

const cohortStatusInitialState = () => ({
  request_enabled: cohortStatusSupported(),
  conditional_access: cohortStatusSupported(),
  request_workspace: cohortStatusSupported(),
});

export default cohortStatusInitialState;
